@use '../../styles/global' as *;
@use '../../styles/kol-card-mixin' as *;
@use '../@shared/mixins' as *;
@use '../tooltip/style.scss' as *;

@layer kol-component {
	@include kol-card;
}
